<template>
  <div style="background-color: #272727; padding: 60px 0">
    <div v-if="languageCode == 'zh'" class="main">
      <div class="logo">
        <img style="width: 159px; height: 52px" src="../../assets/logo1.png" alt="" />
        <p>{{ $t("footer1") }}</p>
        <b></b>
      </div>
      <div style="overflow: hidden; padding-top: 30px">
        <div class="fleft address">
          <p>{{ $t("BeijingOffice") }}：</p>

          <p><i class="icon el-icon-location-outline"></i>{{ $t("BeijingAddress") }}</p>
          <p><i class="icon el-icon-phone-outline"></i>010-62928103</p>
          <p>{{ $t("ChengduOffice") }}：</p>
          <p><i class="icon el-icon-location-outline"></i>{{ $t("ChengduAddress") }}</p>
          <p><i class="icon el-icon-phone-outline"></i>028-62241216</p>
        </div>
        <div class="fleft contact" style="margin-right: 104px">
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t("SalesInquiries") }}</p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;13426119775{{ $t("sales1") }}
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;18602766581{{ $t("sales2") }}
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;13600169756{{ $t("sales3") }}
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;13161840601{{ $t("sales4") }}
          </p>
        </div>
        <div class="fleft contact">
          <p>&nbsp;&nbsp;&nbsp;{{ $t("Email") }}：</p>
          <p>
            &nbsp;&nbsp; {{ $t("Sales") }}：sales@cimomicro.com<br />
            &nbsp;&nbsp;&nbsp;{{ $t("Recruitment") }}：HR@cimomicro.com<br />
            &nbsp;&nbsp;&nbsp;{{ $t("service") }}：info@cimomicro.com
          </p>
        </div>
        <div class="fright">
          <p>{{ $t("FollowUs") }}：</p>
          <img src="../../assets/logo2.png" alt="" />
        </div>
      </div>
      <div style="margin: 30px 0; background-color: #929292; height: 1px"></div>
      <p
        style="
          font-size: 14px;
          text-align: center;
          color: #737373;
          width: 654px;
          margin: 0 auto;
        "
      >
        <a
          href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035603"
          target="_blank"
          rel="noopener noreferrer"
          ><img
            style="float: left; margin-top: 9px"
            src="../../assets/beian.png"
            alt=""
          />
          <span>京公网安备11010802035603号 </span> </a
        >版权所有© 北京士模微电子有限责任公司
        <a href="https://beian.miit.gov.cn" target="_blank">京ICP备2021021129号-1</a
        ><br />
        本网站由阿里云提供云计算及安全服务
      </p>
    </div>
    <div v-if="languageCode == 'en'" class="main">
      <div class="logo">
        <img style="width: 159px; height: 52px" src="../../assets/logo1.png" alt="" />
        <p>{{ $t("footer1") }}</p>
        <b></b>
      </div>
      <div style="overflow: hidden; padding-top: 30px">
        <div class="fleft address">
          <i class="icon el-icon-location-outline"></i><p>{{ $t("BeijingAddress") }}</p>
        </div>
        <div class="fleft contact" style="margin-right: 104px">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="el-icon-phone"></i>&nbsp; Beijing Local：+86 10 62928103
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Nationwide：  +86 13161840601
          </p>
        </div>
        <div class="fleft contact">
          <p>
            &nbsp;&nbsp; <i class="el-icon-message"></i>&nbsp; {{ $t("Sales") }}：sales@cimomicro.com<br />
            &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;  {{ $t("Recruitment") }}：HR@cimomicro.com<br />
            &nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;{{ $t("service") }}：info@cimomicro.com
          </p>
        </div>
        <div class="fright">
          <p>{{ $t("FollowUs") }}：</p>
          <img src="../../assets/logo2.png" alt="" />
        </div>
      </div>
      <div style="margin: 30px 0; background-color: #929292; height: 1px"></div>
      <p
        style="
          font-size: 14px;
          text-align: center;
          color: #737373;
          width: 654px;
          margin: 0 auto;
        "
      >
        <a
          href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035603"
          target="_blank"
          rel="noopener noreferrer"
          ><img
            style="float: left; margin-top: 9px"
            src="../../assets/beian.png"
            alt=""
          />
          <span>京公网安备11010802035603号 </span> </a
        >版权所有© 北京士模微电子有限责任公司
        <a href="https://beian.miit.gov.cn" target="_blank">京ICP备2021021129号-1</a
        ><br />
        本网站由阿里云提供云计算及安全服务
      </p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    languageCode() {
      // 注意：根据你项目实际使用的 i18n 实例名称来写
      // 常见的是 this.$i18n.locale
      // 如果确实用了 this.$i18nState，就保留
      return this.$i18nState.locale?this.$i18nState.locale :  'zh';
      
    },
  }
};
</script>
<style lang="scss" scoped>
p {
  line-height: 40px;
  color: #fff;
}
.logo {
  overflow: hidden;
  display: flex;
  height: 52px;
  img {
    float: left;
  }
  p {
    padding-top: 24px;
    text-indent: 30px;
    display: inline-block;
    padding-right: 20px;
  }
  b {
    display: inline-block;
    flex: 1;
    height: 1px;
    margin-top: 50px;
    background-color: #fff;
  }
}
.icon {
  display: inline-block;
  margin-right: 4px;
  color:#fff;
  float:left;
  margin-top:14px;
}
.lang-en .address {
  width: 300px;
  margin-right: 10px;
  p{
    display:inline-block;
    float:left;
    width:280px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue